<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

export default {
  data() {
    return {
      // The user's old password (input)
      password: "",

      // The new password
      newPassword: "",

      // The new password confirmation
      confirmPassword: "",
    };
  },

  computed: {
    // Mapped vuex state
    ...mapState(["teams"]),
    ...mapGetters(["authenticated"]),
  },

  watch: {
    // When the password changes, validate whether the passwords match
    password() {
      this.validate();
    },

    // When the password confirmation changes, validate whether the
    // passwords match
    confirmPassword() {
      this.validate();
    },
  },

  methods: {
    // Set the validity state of the password confirmation input to
    // indicate whether the passwords match
    validate() {
      if (
        this.newPassword &&
        this.confirmPassword &&
        this.newPassword != this.confirmPassword
      ) {
        this.$refs.confirmPasswordInput.setCustomValidity(
          "Passwords do not match"
        );
      } else {
        this.$refs.confirmPasswordInput.setCustomValidity("");
      }
    },

    // On submit, post the the API the password change
    async submit() {
      let success = await this.changePassword({
        password: this.password,
        newPassword: this.newPassword,
      });

      // If it was successful, clear the fields
      if (success) {
        this.password = "";
        this.newPassword = "";
        this.confirmPassword = "";
      }
    },

    // Mapped vuex actions
    ...mapActions(["changePassword"]),
    ...mapMutations(["setActiveTeamId"]),
  },
};
</script>

<template>
  <b-card>
    <b-card-text>
      <b-form @submit.stop.prevent="submit">
        <b-form-group
          id="password-group"
          label="Current Password"
          label-for="password"
        >
          <b-form-input
            required
            id="password"
            type="password"
            v-model="password"
            placeholder="Current Password"
          ></b-form-input>
        </b-form-group>
        <b-row>
          <b-col cols="12" sm="6">
            <b-form-group
              id="password-group"
              label="New Password"
              label-for="new-password"
            >
              <b-form-input
                required
                id="new-password"
                type="password"
                v-model="newPassword"
                placeholder="New Password"
                minlength="8"
              ></b-form-input>
              <small class="form-text text-muted">
                Password must be at least 8 characters.
              </small>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6">
            <b-form-group
              id="confirm-password-group"
              label="Confirm New Password"
              label-for="confirm-password"
            >
              <input
                required
                ref="confirmPasswordInput"
                id="confirm-password"
                type="password"
                v-model="confirmPassword"
                placeholder="Confirm New Password"
                class="form-control"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-button type="submit" variant="primary">Change Password</b-button>
      </b-form>
    </b-card-text>
  </b-card>
</template>
